import { Valence } from '../../types';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';

export interface ValuesOfImpactCategory {
  [Valence.POSITIVE]: number;
  [Valence.NEGATIVE]: number;
  [valence: string]: number;
}

export type ValueSet = {
  [i in ImpactCategoryId]: ValuesOfImpactCategory;
};

export type ValueSets = {
  [id in ValueSetId]: ValueSet;
};

export interface PredefinedValueset {
  id: ValueSetId;
  title: string;
  description: string;
  valueSet: ValueSet;
  keyTakeawayText: string;
  hidden?: boolean;
}

// OA: If you delete old ones from here, the key takeaways from old versions may show funnily in UI.
// Also, the string values must match the keys in the value set json files.
export enum ValueSetId {
  EQUAL_WEIGHTS = 'EQUAL_WEIGHTS',
  FINLAND = 'FINLAND',
  FIGHTING_CLIMATE_CHANGE = 'FIGHTING_CLIMATE_CHANGE',
  HEALTH_FIRST = 'HEALTH_FIRST',
  KNOWLEDGE_FIRST = 'KNOWLEDGE_FIRST',
  TAXES_AND_JOBS = 'TAXES_AND_JOBS',
  NIR_MILLENIAL = 'NIR_MILLENIAL',
  NIR_BOOMER = 'NIR_BOOMER',
  NIR_WORKING = 'NIR_WORKING',
  NIR_MOST_WANTED = 'NIR_MOST_WANTED',
  NIR_FEMALE = 'NIR_FEMALE',
  NIR_ASSET_MANAGER = 'NIR_ASSET_MANAGER',
  NIR_ASSET_OWNER = 'NIR_ASSET_OWNER',
  NIR_SMALL_AUM = 'NIR_SMALL_AUM',
  NIR_BIG_AUM = 'NIR_BIG_AUM',
  NIR_VC = 'NIR_VC',
  NIR_PORTFOLIO_MANAGER = 'NIR_PORTFOLIO_MANAGER',
  NIR_CEO = 'NIR_CEO',
  NIR_HEAD_OF_ESG = 'NIR_HEAD_OF_ESG',
  NIR_VALUE_FOR_SOCIETY = 'NIR_VALUE_FOR_SOCIETY',
}
